import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { FlexColumn, FlexRow } from '../../atoms/layout/Flex'
import Button from '../../atoms/inputs/Button'
import { CompanySelectors } from '../../../store/company/selectors'
import List from '../../atoms/display/List'
import ListItem from '../../atoms/display/ListItem'
import { BranchOffice } from '../../../types/Company'
import {
  useBranchOfficeCreateDialog,
  useBranchOfficeDeleteDialog,
  useBranchOfficeEditDialog,
  useBranchOfficeMemberAddDialog,
  useBranchOfficeMemberRemoveDialog,
} from '../../../hooks/useDialog'
import Label from '../../atoms/display/Label'
import IconButton from '../../atoms/inputs/IconButton'
import { DeleteIcon, EditIcon } from '../../atoms/display/Icons'

export default function CompanyBranchOffices() {
  const branchOffices = useSelector(CompanySelectors.branchOffices)
  const [selectedBranchOffice, setSelectedBranchOffice] = useState<BranchOffice | null>(null)
  const users = useSelector(CompanySelectors.users)
  const branchOfficeCreateDialog = useBranchOfficeCreateDialog()
  const branchOfficeEditDialog = useBranchOfficeEditDialog()
  const branchOfficeDeleteDialog = useBranchOfficeDeleteDialog()
  const branchOfficeMemberAddDialog = useBranchOfficeMemberAddDialog()
  const branchOfficeMemberRemoveDialog = useBranchOfficeMemberRemoveDialog()

  useEffect(() => {
    if (branchOffices.length > 0) {
      if (selectedBranchOffice === null) {
        setSelectedBranchOffice(branchOffices[0])
      }
    } else {
      setSelectedBranchOffice(null)
    }
  }, [branchOffices, selectedBranchOffice])

  return (
    <FlexRow space={4}>
      <FlexColumn width={480}>
        <FlexRow align="center">
          <Label text="支店一覧" variant="subtitle" />
          <Button height="small" onClick={() => branchOfficeCreateDialog.open()}>
            支店追加
          </Button>
        </FlexRow>
        {branchOffices.length === 0 ? (
          <Label text="支店の登録がありません" />
        ) : (
          <List>
            {branchOffices.map((branchOffice) => (
              <ListItem
                key={branchOffice.id}
                selected={branchOffice.id === selectedBranchOffice?.id}
                onClick={() => setSelectedBranchOffice(branchOffice)}
              >
                <FlexRow width="100%" justify="space-between" align="center">
                  <Label text={branchOffice.name} />
                  <FlexRow scroll={false}>
                    <IconButton label="編集" onClick={() => branchOfficeEditDialog.open(branchOffice)}>
                      <EditIcon />
                    </IconButton>
                    <IconButton label="削除" onClick={() => branchOfficeDeleteDialog.open(branchOffice)}>
                      <DeleteIcon />
                    </IconButton>
                  </FlexRow>
                </FlexRow>
              </ListItem>
            ))}
          </List>
        )}
      </FlexColumn>
      {selectedBranchOffice && (
        <FlexColumn width={300}>
          <FlexRow align="center">
            <Label text="メンバー一覧" variant="subtitle" />
            <Button height="small" onClick={() => branchOfficeMemberAddDialog.open(selectedBranchOffice)}>
              メンバー追加
            </Button>
          </FlexRow>
          {selectedBranchOffice.members.length === 0 ? (
            <Label text="メンバーが登録されていません" />
          ) : (
            <List>
              {selectedBranchOffice.members.map((userId) => {
                const user = users.find((u) => u.id === userId)
                if (user) {
                  return (
                    <ListItem key={userId}>
                      <FlexRow justify="space-between" align="center" width="100%">
                        <Label text={user.name} />
                        <FlexRow>
                          <IconButton
                            label="外す"
                            onClick={() => branchOfficeMemberRemoveDialog.open(selectedBranchOffice, user)}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </FlexRow>
                      </FlexRow>
                    </ListItem>
                  )
                }
                return undefined
              })}
            </List>
          )}
        </FlexColumn>
      )}
    </FlexRow>
  )
}
